import { Component } from '@angular/core';
import { LoginContext } from 'src/services/login-context.model';
import { ApiService } from 'src/services/api.service';
import { CredentialsService } from 'src/app/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { matchingPasswords } from 'src/services/validation';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

  profile: LoginContext | null;
  changePasswordForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  returnUrl: string;
  errorMsg: string = 'default';
  currentUser: any;

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private apiService: ApiService,
              private credentialsService: CredentialsService,
              private toastService: ToastService) {
    this.profile = this.credentialsService.credentials;
    this.currentUser = this.profile.user;
    this.changePasswordForm = this.initializeForm();
  }

  initializeForm(): FormGroup {
    return this.changePasswordForm = this.formBuilder.group({
      'password' : ['', Validators.required],
      'confirmPassword' : ['', Validators.required],
    }, { validator: matchingPasswords('password', 'confirmPassword') });
  }

  get changePasswordFormControl(){
    return this.changePasswordForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.changePasswordForm.valid){
      this.loading = true;
      const returnUrl: string = "/login";
      this.apiService.post_("/auth/change/password", this.changePasswordForm.value).pipe(
        finalize((): void => {
          this.loading = false;
        })
      ).subscribe((response:any): void =>{
        if (response.success && response.status == "OK"){
          this.profile.user = response.data;
          this.credentialsService.updateCredentials(this.profile);
          this.router.navigate([returnUrl]);
          this.toastService.showSuccess("Password Changed Succesfully! Please Re-login with new credential.");
        }
        else{
          this.toastService.showDanger("Your Change Password Request Could Not Be Processed: " + response.message);
        }
      }, (error) =>{
        console.log(error);
        this.toastService.showDanger("Request Could Not Be Processed at this time! Please Try Again later!");
      })
    }

  }

}
